import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import './Membership360.css';
import { PILLARS, SCARCITY, getPillar } from './orbitContent';

const OrbitWayPage = () => {
  const { wayId } = useParams();
  const pillar = getPillar(wayId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [wayId]);

  if (!pillar) {
    return <Navigate to="/orbit/what-you-get" replace />;
  }

  const others = PILLARS.filter((p) => p.id !== wayId);

  return (
    <main className="m360 od" style={{ '--od-accent': pillar.color }}>
      <header className="od-hero">
        <div className="m360-wrap">
          <p className="od-emoji" aria-hidden="true">
            {pillar.icon}
          </p>
          <h1>{pillar.title}</h1>
          <p className="od-line">{pillar.blurb}</p>
        </div>
      </header>

      <section className="od-band" style={{ '--od-accent': pillar.color }}>
        <div className="m360-wrap">
          <h2>Variations</h2>
          <div className="od-chips od-chips-light">
            {pillar.variations.map((v) => (
              <span key={v} className="od-chip">
                <span className="od-chip-text">{v}</span>
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="od-block">
        <div className="m360-wrap od-actions">
          <Link className="m360-btn m360-btn-primary" to="/orbit/join#interest">
            {SCARCITY.cta}
          </Link>
          <Link className="m360-btn m360-btn-ghost" to={pillar.to}>
            Open offer →
          </Link>
        </div>
      </section>

      <section className="od-block od-more">
        <div className="m360-wrap">
          <p className="od-more-label">Other ways</p>
          <div className="od-more-row">
            {others.map((p) => (
              <Link key={p.id} to={`/orbit/ways/${p.id}`}>
                <span className="od-ico" aria-hidden="true">
                  {p.icon}
                </span>
                <span className="od-chip-text">{p.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default OrbitWayPage;
